import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import TipoArticuloStatusMessage from "common/components/StatusMessage/TipoArticuloStatusMessage"
import createImgURI from "common/utils/createImgURI"
import { formatCurrency } from "common/utils/currency"
import { truncateString } from "common/utils/formats"
import { nanoid } from "nanoid"
import { Button } from "primereact/button"
import { Tooltip } from "primereact/tooltip"
import { useArticulosContext } from "../context/ArticulosContextProvider"
import "./templates.scss"

export const PrecioVentaBodyTemplate = ({ precioVenta }: $TSMigrationFixMe) => {
  return <span>{formatCurrency(precioVenta)}</span>
}

export const TipoArticuloBodyTemplate = ({
  tipoArticulo,
}: $TSMigrationFixMe) => {
  return <TipoArticuloStatusMessage tipoArticulo={tipoArticulo} />
}

export const EditArticulosBodyTemplate = ({ rowData }: $TSMigrationFixMe) => {
  // @ts-expect-error TS(2339): Property 'editArticulo' does not exist on type '{}...
  const { editArticulo, deleteArticulo } = useArticulosContext()

  return (
    <div className='d-flex justify-content-end'>
      <Button
        className='p-button-raised p-button-text p-button-secondary icon-table icon-table__simple'
        onClick={(e) => {
          e.stopPropagation()
          editArticulo(rowData)
        }}
      >
        {/* @ts-expect-error TS(2322): Type '"fa-light"' is not assignable to type 'IconP... */}
        <FontAwesomeIcon icon={["fa-light", "pen"]} />
      </Button>
      <Button
        className='icon-table ml-2 p-button-raised icon-table p-button-text p-button-secondary'
        onClick={(e) => {
          e.stopPropagation()
          deleteArticulo(rowData)
        }}
      >
        {/* @ts-expect-error TS(2322): Type '"fa-light"' is not assignable to type 'IconP... */}
        <FontAwesomeIcon icon={["fa-light", "fa-trash-can"]} />
      </Button>
    </div>
  )
}

export const ImageArticuloBodyTemplate = ({
  concepto,
  thumbnailBase64,
  thumbnailMediaType,
  imagenBase64,
  imagenMediaType,
}: $TSMigrationFixMe) => {
  const imgBase64 = thumbnailBase64 || imagenBase64
  const imgMediaType = thumbnailMediaType || imagenMediaType

  if (!imgBase64) {
    return null
  }

  return (
    <img
      className='articulo-img'
      src={createImgURI(imgBase64, imgMediaType)}
      alt={`Imagen del artículo ${concepto}`}
    />
  )
}

export const TipoArticuloMultiselectBodyTemplate = ({
  label,
  value,
}: $TSMigrationFixMe) => {
  return (
    <div className={`estado-estudio-${value}`}>
      <div className='ellipsis'>{label}</div>
    </div>
  )
}

export const CategoriasBodyTemplate = ({ categorias }: $TSMigrationFixMe) => {
  const categoriasNames = categorias
    ?.map(({ nombre }: $TSMigrationFixMe) => nombre)
    .join(", ")
  const targetSelector = `${nanoid()}`.replace(/[_|-|0-9]/g, "").toLowerCase()

  return (
    <span className='text-gedesco text-truncate'>
      <Tooltip
        target={`.${targetSelector}`}
        content={categoriasNames}
      />
      <span className={targetSelector}>
        {truncateString({ str: categoriasNames, maxLength: 50 })}
      </span>
    </span>
  )
}
